const bulkOrderCardData = {
  link: '/lp-corporate-gifting-website/',
  title: 'Bulk Order for Business',
  name: 'Bulk Order for Business',
  image: {
    sourceUrl:
      'https://cart.gourmetbasket.com.au/wp-content/uploads/2024/07/bulk-order-for-business.jpg',
    altText: 'Bulk Order for Business',
    sizes: '',
    title: 'Bulk Order for Business',
  },
  id: 20668624,
};

export default bulkOrderCardData;
